import React from 'react';
import { Grid, Typography } from '@mui/material';

const TransactionsDrawerSimple = ({ selectedTransactionData }) => {
  if (!selectedTransactionData) {
    return (
      <div>
        <Typography variant="h6">No data available</Typography>
      </div>
    );
  }

  const divideIntoColumns = (data) => {
    const keys = Object.keys(data || {});
    const middleIndex = Math.ceil(keys.length / 2);
    const firstColumnKeys = keys.slice(0, middleIndex);
    const secondColumnKeys = keys.slice(middleIndex);

    return (
      <>
        {/* First column */}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          {firstColumnKeys.map((key) => (
            <div key={key} style={{ marginBottom: '8px' }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {key.toUpperCase()}
              </Typography>
              <Typography variant="body1">{data[key]}</Typography>
            </div>
          ))}
        </Grid>

        {/* Second column */}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: '-8px' }}>
          {secondColumnKeys.map((key) => (
            <div key={key} style={{ marginBottom: '8px' }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {key.toUpperCase()}
              </Typography>
              <Typography variant="body1">{data[key]}</Typography>
            </div>
          ))}
        </Grid>
      </>
    );
  };

  return (
    <div>
      <Grid container spacing={2}>
        {divideIntoColumns(selectedTransactionData)}
      </Grid>
    </div>
  );
};

export default TransactionsDrawerSimple;